module.exports = __webpack_public_path__ + "static/media/just wait around-01.fbbd2926.png";